import { TeamMemberRole } from "~graphql/generated/graphql"

import usePublicTeamMembers from "./use-public-team-members"

export default function useOwnersAndCoOwners({
    outfitterId,
}: {
    outfitterId: string
}) {
    const { teamMembers: owners, isLoading: isLoadingOwners } =
        usePublicTeamMembers({
            outfitterId,
            role: TeamMemberRole.Owner,
        })

    const { teamMembers: coOwners, isLoading: isLoadingCoOwners } =
        usePublicTeamMembers({
            outfitterId,
            role: TeamMemberRole.CoOwner,
        })

    const allOwners = [...owners, ...coOwners]
    const isLoading = isLoadingOwners || isLoadingCoOwners

    return { allOwners, isLoading }
}
